module.exports = __webpack_public_path__ + "static/media/image-card-3.b6a01c45.png";